var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"languageSelectorWrapper mt-4 mr-2"},[_vm._v(" "+_vm._s(_vm.$t('Language'))+": "),_c('v-select',{staticClass:"languageSelector",attrs:{"items":[
      { text: _vm.$t('Hungarian'), value: 'hu' },
      { text: _vm.$t('English'), value: 'en' }
    ]},model:{value:(_vm.$i18n.locale),callback:function ($$v) {_vm.$set(_vm.$i18n, "locale", $$v)},expression:"$i18n.locale"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }